// 16: הגשר של בלוקי app לכל האפליקציה (מסך ריצה, יצירה, שיחה — display.preview של בלוק עם source.runId).
// context נפרד מ-DisplayContext — Screen/TurnView לא משתנים. כרטיס הקונסנט פותח את מגירת הקונסנט (?consent=<id>).
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { AppCallContext, type AppCallBridge } from '@aibify/display/client';
import { appCall, appPeek, warmRun } from '../lib/appCalls.ts';
import { api } from '../lib/api.ts';
import { consentHref } from './ConsentDrawer.tsx';

export function AppCallsProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const loc = useLocation();
  const bridge = useMemo<AppCallBridge>(
    () => ({
      call: (runId, action, args, signal, o) => appCall(runId, action, args, signal, false, o),
      peek: (runId, action, args) => appPeek(runId, action, args),
      warm: (runId) => void warmRun(runId),
      openConsent: (id) => navigate(consentHref(loc.search, id)),
      // display.preview של האפליקציה שריצה בנתה (source.runId בלי html) — הפלט בהרשאת הצופה; ריצה שלא הסתיימה → null
      runOutput: (runId) => api.getRun(runId).then((r) => (r.status === 'done' ? r.output : null)),
    }),
    [navigate, loc.search],
  );
  return <AppCallContext.Provider value={bridge}>{children}</AppCallContext.Provider>;
}
